export const toFixedNoRounding = (value, n) => {
    const reg = new RegExp('^-?\\d+(?:\\.\\d{0,' + n + '})?', 'g');
    const a = value.toString().match(reg)[0];
    const dot = a.indexOf('.');
    if (dot === -1) {
        // integer, insert decimal dot and pad up zeros
        return a + '.' + '0'.repeat(n);
    }
    const b = n - (a.length - dot) + 1;
    return b > 0 ? a + '0'.repeat(b) : a;
};

export const oneDecimalRound = (value) => {
    return value !== null && value !== undefined ? Math.round(value * 10) / 10 : null;
};

/**
 * Rounds a number up to a maximum of 2 decimals (if needed) using system precision for accurate rounding
 * @param num - the number to round
 * @returns {number} - the rounded number
 */
export const twoDecimalsRound = (num) => {
    if (typeof num === 'number') {
        return Math.round((num + Number.EPSILON) * 100) / 100;
    } else if (typeof num === 'string') {
        const number = parseFloat(num);
        if (number) {
            return Math.round((number + Number.EPSILON) * 100) / 100;
        }
    }
    return 0;
};

/**
 * Restricts the input to one decimal
 *
 * @param numberFormat - the number format in which the number is displayed
 * @param inputEl - the input element returned by jQuery selector
 * @param inputMaxLength - the maximum length the input is expected to have in the worst case
 */
export const restrictToOneDecimal = function(numberFormat, inputEl, inputMaxLength) {
    const value = inputEl.val();
    const separatorChar = numberFormat === 'decimal_comma' ? ',' : '.';
    const regex = separatorChar === ',' ? /^[0-9]+,[0-9]$/ : /^[0-9]+\.[0-9]$/;
    const re = new RegExp(regex, 'g');
    const isValid = re.test(value);

    const length = value.length;
    // if the value doesn't have a decimal and the input length is less than the maximum possible reset maxlength attribute
    if (length < inputMaxLength && !isValid) {
        inputEl.attr('maxlength', inputMaxLength);
    }
    // if the value has exactly one decimal don't let user add more
    if (isValid) {
        inputEl.attr('maxlength', length);
    }
};

/**
 * Gets a range between two numbers
 *
 * @param {number} start the beginning of the range
 * @param {number} end the end of the range, which can be greater than the start value for an
 *                     ascending range or less than the start value for a descending range
 * @param {number} [step] the interval between each item in the range (1 by default)
 * @returns the range
 */
export const range = (start, end, step = 1) =>
    Array.from(
        { length: Math.ceil((Math.abs(end - start) + 1) / step) },
        (_, i) => start + i * step * Math.sign(end - start)
    );
